import { useEffect, useState } from "react";
import axios from "axios";
import moment from "moment";
import clsx from "clsx";
import { toast } from "react-toastify";
import { UsagesModal } from "../usages-modal/UsagesModal";
import { PromoCycleModal } from "../../../PromoCode/PromoCycleModal/PromoCycleModal";
import FileDownload from "js-file-download";

const PromoModalForm = ({
  selectedListingId,
  setSelectedListingId,
  setOpenPromoModal,
  listing,
}) => {
  const [promoCodes, setPromoCodes] = useState([])
  const [pageSize, setPageSize] = useState(50);
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(1);
  const [promoCycleId, setPromoCycleId] = useState(null);
  const [openPromoCycleModal, setOpenPromoCycleModal] = useState(false);
  const [openUsagesModal, setOpenUsagesModal] = useState(false);
  const [usages, setUsages] = useState([]);
  const [promoCode, setPromoCode] = useState("");
  const [displayType, setDisplayType] = useState('list')
  const [isLoading, setIsLoading] = useState(false)

  const cancel = () => {
    setSelectedListingId();
    setOpenPromoModal(false);
  };


  const updatePage = (type) => {
    if (type === "dec" && page > 1 && page !== 1) {
      setPage(page - 1);
    } else if (type === "inc" && page >= 1) {
      if (page !== Math.ceil(total / pageSize)) {
        setPage(page + 1);
      }
    } else {
      setPage(type);
    }
  };



  const getPromoCode = () => {
    axios.get(`${process.env.REACT_APP_API_URL}/promo?page=${page}&page_size=${pageSize}&listing_id=${selectedListingId}`)
      .then(res => {
        setPromoCodes(res.data.promo_codes);
        setTotal(res.data.total);
      });
  }

  useEffect(() => {
    getPromoCode();
  }, [page, pageSize]);


  const getBookings = (code, usages) => {
    axios
      .get(`${process.env.REACT_APP_API_URL}/booking?page=1&page_size=${usages}&promo_code=${code}`)
      .then(res => {
        setUsages(res.data.bookings);
        setPromoCode(code);
        setOpenUsagesModal(true);
      })
      .catch(err => {
        toast.error(err?.response?.data?.message || "Error");
      });
  };

  const downloadFile = async () => {
    setIsLoading(true);
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/promo/cycles/download?listing_id=${listing.listing_id}`,
        null,
        { responseType: 'blob' }
      );
      const disposition = response.headers['content-disposition'];
      let filename = 'promo_code.xlsx';
      if (disposition && disposition.includes('filename=')) {
        const match = disposition.match(/filename="?([^"]+)"?/);
        if (match && match[1]) {
          filename = match[1];
        }
      }
      const blob = new Blob([response.data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });
      FileDownload(blob, filename);
      toast.success('Promo code file downloaded successfully');
      setIsLoading(false);
    } catch (error) {
      toast.error('Error downloading file');
      setIsLoading(false);
    }
  };


  return (
    <>
      <div className="kt_body">
        <div className="nav-group nav-group-fluid mb-3 d-inline-block">
          <label>
            <input
              type="radio"
              className="btn-check"
              name="type"
              checked={displayType === 'list'}
              onChange={() => {
                setDisplayType('list')
              }}
            />
            <span className="btn btn-sm btn-active btn-active-primary fs-6 fw-bold">
              List View
            </span>
          </label>
          <label>
            <input
              type="radio"
              className="btn-check"
              name="type"
              checked={displayType === 'grid'}
              onChange={() => {
                setDisplayType('grid')
              }}
            />
            <span className="btn btn-sm btn-active btn-active-primary px-4 fs-6 fw-bold">
              Grid View
            </span>
          </label>
        </div>
        <div style={{ maxHeight: '310px', overflowY: `${displayType === 'grid' ? 'auto' : 'hidden'}`, minHeight: 'auto', display: 'grid', gap: '10px', gridTemplateColumns: `${displayType === 'grid' ? 'repeat(2, 1fr)' : '1fr'}` }}>
          {
            !!promoCodes.length ?
              <>
                {displayType === 'list' ?
                  <List promos={promoCodes} getBookings={getBookings} setOpenPromoCycleModal={setOpenPromoCycleModal} setPromoCycleId={setPromoCycleId} />
                  :
                  <Grid promos={promoCodes} getBookings={getBookings} setOpenPromoCycleModal={setOpenPromoCycleModal} setPromoCycleId={setPromoCycleId} />}
              </>
              :
              <h4>No Promo Codes Available for this Listing</h4>
          }
        </div>
        <div className="row mt-10">
          <div className="col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start">
            <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
              <select
                className="form-select form-select-solid fw-bolder"
                data-kt-select2="true"
                data-placeholder="Select Status"
                data-allow-clear="true"
                data-kt-user-table-filter="two-step"
                data-hide-search="true"
                onChange={(e) => setPageSize(e.target.value)}
                value={pageSize}
              >
                <option value="50">50</option>
                <option value="100">100</option>
                <option value="200">200</option>
                <option value="500">500</option>
              </select>
            </div>
          </div>
          <div className="col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-lg-end">
            <div id="kt_table_users_paginate">
              {total > 0 && <ul className="pagination">
                {page > 1 && (
                  <li className={clsx("page-item", "previous")}>
                    <button
                      className={clsx("page-link", "next", "page-text")}
                      onClick={() => updatePage("dec")}
                      style={{ cursor: "pointer" }}
                      disabled={page === 1}
                    >
                      Previous Page
                    </button>
                  </li>
                )}
                <div style={{ display: "flex", gap: "5px", fontWeight: 700, fontSize: "14px" }}>
                  <span style={{ color: "#ffa459" }}>{page}</span>/ {Math.ceil(total / pageSize)}
                </div>
                <li className={clsx("page-item", "previous")}>
                  <button
                    className={clsx("page-link")}
                    onClick={() => updatePage("inc")}
                    style={{
                      cursor: page !== Math.ceil(total / pageSize) ? "pointer" : "default",
                      background: page !== Math.ceil(total / pageSize) ? "transparent" : "#e6e6e6",
                      color: page !== Math.ceil(total / pageSize) ? "#5e6278" : "#b2b2b2",
                      marginLeft: page === Math.ceil(total / pageSize) && "10px"
                    }}
                  >
                    Next Page
                  </button>
                </li>
                {Math.ceil(total / pageSize) > 5 && <div style={{ display: "flex", gap: "10px", alignItems: "center", marginLeft: '10px' }}>
                  <h6 style={{ marginBottom: '0' }}>Go To Page: </h6>
                  <select
                    style={{ width: "max-content" }}
                    className="form-select form-select-solid fw-bolder"
                    data-kt-select2="true"
                    data-placeholder="Select Status"
                    data-allow-clear="true"
                    data-kt-user-table-filter="two-step"
                    data-hide-search="true"
                    onChange={(e) => updatePage(+e.target.value)}
                    value={page}
                  >
                    {
                      [...Array(Math.ceil(total / pageSize))].map((_, i) => {
                        return (
                          <option value={i + 1}>{i + 1}</option>
                        )
                      }
                      )}
                  </select>
                </div>
                }
              </ul>
              }
            </div>
          </div>
        </div>
        <div className="d-flex gap-2 mt-5 justify-content-center">
          <button
            type="button"
            className="btn btn-sm btn-primary"
            onClick={() => cancel()}
          >
            Go Back
          </button>
          {/* <button
            type="button"
            className="btn btn-sm bg-success text-white"
            disabled={isLoading}
            onClick={() => downloadFile()}
          >
            Download Codes
          </button> */}
        </div>
      </div>
      {
        openPromoCycleModal && <PromoCycleModal
          promoCycleId={promoCycleId}
          setPromoCycleId={setPromoCycleId}
          setOpenPromoCycleModal={setOpenPromoCycleModal}
          getBookings={getBookings}
        />
      }
      {openUsagesModal && (
        <UsagesModal
          promo={promoCode}
          usages={usages}
          onClose={() => {
            setPromoCode("");
            setUsages([]);
            setOpenUsagesModal(false);
          }}
        />
      )}
    </>
  );
};

export { PromoModalForm };

export const Grid = ({ promos, getBookings, setOpenPromoCycleModal, setPromoCycleId }) => {
  return promos.map((item, index) => {
    return (
      <div
        className="form-check form-check-custom form-check-solid"
        key={index}
        style={{
          background: "#e3feee9e",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "10px",
          borderRadius: "10px",
          flexWrap: "wrap"
        }}
      >
        <div className="fv-row w-50">
          <label className="fw-bold fs-6 mb-2">Promo Code</label>
          <h5 style={{ color: "#ffa459", fontWeight: 700 }}>{item.code}</h5>
        </div>
        <div className="fv-row w-50" style={{ textAlign: "right" }}>
          <label className="fw-bold fs-6 mb-2">Promo Code Type</label>
          <h5 style={{ color: "#ffa459", fontWeight: 700 }}>
            {+item.promo_type === 1 ? "Hourly"
              : +item.promo_type === 2 ? "Daily"
                : +item.promo_type === 3 ? "Weekly"
                  : +item.promo_type === 4 ? "Monthly"
                    : "For All"
            }
          </h5>
        </div>
        <div className="fv-row w-50">
          <label className="fw-bold fs-6 mb-2">Discount Type</label>
          <h5 style={{ color: "#ffa459", fontWeight: 700 }}>
            {+item.discount_type === 1 ? "Flat"
              : +item.discount_type === 2 ? "Percentage"
                : (+item.discount_type === 3 && item?.is_ffa) ? `${item.duration} ${item.duration === 1 ? +item.promo_type === 1 ? "Hour" : "Day" : +item.promo_type === 1 ? "Hours" : "Days"} Off`
                  : (+item.discount_type === 3 && !item?.is_ffa) ? `X Amount of ${+item.promo_type === 1 ? "Hours" : "Days"} OFF`
                    : ""
            }
          </h5>
        </div>
        <div className="fv-row w-50" style={{ textAlign: "right" }}>
          <label className="fw-bold fs-6 mb-2">Discount Value</label>
          <h5 style={{ color: "#ffa459", fontWeight: 700 }}>
            {+item.discount_type === 1 ? `$${(item?.discount / 100)?.toFixed(2)}`
              : +item.discount_type === 2 ? `${item.discount}%`
                : +item.discount_type === 3 ? item.is_ffa ? "Free For All"
                  : item.duration : ""
            }
          </h5>
        </div>
        <div className="fv-row w-50">
          <label className="fw-bold fs-6 mb-2">Start Date</label>
          <h5 style={{
            color: "#ffa459",
            fontWeight: 700
          }}>{item.start_date ? moment(item.start_date).format("YYYY-MM-DD") : moment(item.createdAt).format("YYYY-MM-DD")}</h5>
        </div>
        <div className="fv-row w-50" style={{ textAlign: "right" }}>
          <label className="fw-bold fs-6 mb-2">Expiration Date</label>
          <h5 style={{
            color: "#ffa459",
            fontWeight: 700
          }}>{moment(item.expiry_date).utc().format("YYYY-MM-DD")}</h5>
        </div>
        <div className="fv-row w-50">
          <label className="fw-bold fs-6 mb-2">Total Usage</label>
          <div
            style={{ display: "flex", alignItems: "center", columnGap: "6px" }}>
            <h5 style={{ color: "#ffa459", fontWeight: 700, margin: "0" }}>{item.total_usage || "0"}
            </h5>
            {!!item.total_usage && (
              <button
                style={{
                  backgroundColor: "rgb(255, 164, 89)",
                  border: "none",
                  color: "white",
                  borderRadius: "2px",
                  padding: '4px'
                }}
                onClick={() => getBookings(item.code, item.total_usage || 1)}
              >
                Show
              </button>
            )}
          </div>
        </div>
        <div className="fv-row w-50" style={{ textAlign: "right" }}>
          <label className="fw-bold fs-6 mb-2">Total Uses Allowed</label>
          <h5 style={{ color: "#ffa459", fontWeight: 700 }}>{item.limit_overall || "-"}</h5>
        </div>
        <div className="fv-row w-50">
          <label className="fw-bold fs-6 mb-2">Total Usage Per User</label>
          <h5 style={{ color: "#ffa459", fontWeight: 700 }}>
            {item.limit_user || "-"}
          </h5>
        </div>
        <div className="fv-row w-50" style={{ textAlign: "right" }}>
          <label className="fw-bold fs-6 mb-2">Promo End Date</label>
          <h5 style={{
            color: "#ffa459",
            fontWeight: 700
          }}>{moment(item.expiry_date).utc().format("YYYY-MM-DD")}</h5>
        </div>
        <div className="fv-row w-50">
          <label className="fw-bold fs-6 mb-2">Created At</label>
          <h5 style={{ color: "#ffa459", fontWeight: 700 }}>{moment(item.createdAt).format("YYYY-MM-DD")}</h5>
        </div>
        {(item.is_ffa && item.is_cyclic) && (
          <>
            <div className="fv-row w-50" style={{ textAlign: "right" }}>
              <label className="fw-bold fs-6 mb-2">Is Cyclic</label>
              <h5 style={{ color: "#ffa459", fontWeight: 700 }}>{item.is_cyclic ? "Yes" : "No"}
                {item.is_cyclic && (
                  <button
                    style={{
                      backgroundColor: "rgb(255, 164, 89)",
                      border: "none",
                      color: "white",
                      borderRadius: "2px",
                      marginLeft: "6px",
                      padding: '4px'
                    }}
                    onClick={() => {
                      setPromoCycleId(item.cycle_id);
                      setOpenPromoCycleModal(true);
                    }}
                  >
                    Show All
                  </button>
                )}
              </h5>
            </div>
          </>
        )}
        <div className="fv-row w-100">
          <label className="fw-bold fs-6 mb-2">Note</label>
          <h5 style={{ color: "#ffa459", fontWeight: 700 }}>{item.notes ? item.notes : '-'}</h5>
        </div>
      </div>
    )
  })
}

export const List = ({ promos, getBookings, setOpenPromoCycleModal, setPromoCycleId }) => {

  const headers = [
    { title: 'Promo Code', width: '180px' },
    { title: 'Promo Type', width: '120px' },
    { title: 'Discount Type', width: '120px' },
    { title: 'Discount Value', width: '150px' },
    { title: 'Start Date', width: '150px' },
    { title: 'Expiration Date', width: '150px' },
    { title: 'Total Usage', width: '150px' },
    { title: 'Total Usage Allowed', width: '180px' },
    { title: 'Total Usage Per User', width: '180px' },
    { title: 'Promo End Date', width: '150px' },
    { title: 'Created At', width: '150px' },
    { title: 'Is Cyclic', width: '180px' },
  ]

  return (
    <div className='table-responsive' style={{ height: '320px' }}>
      <table
        id='kt_table_users'
        className='table align-middle table-row-dashed fs-6 gy-5 dataTable no-footer'
      >
        <thead>
          <tr className='text-start text-muted fw-bolder fs-7 text-uppercase gs-0'>
            {headers.map(column => (
              <th
                key={column.title}
                className={column.className}
                style={{ minWidth: column.width }}
              >
                {column.title}
              </th>
            ))}
          </tr>
        </thead>
        <tbody className='text-gray-600 fw-bold'>
          {promos?.length > 0 && (
            promos.map(row => (
              <tr key={row.arrear_id}>
                <td style={{ minWidth: headers[0].width }}>{row.code}</td>
                <td style={{ minWidth: headers[1].width }}>
                  {+row.promo_type === 1 ? "Hourly"
                    : +row.promo_type === 2 ? "Daily"
                      : +row.promo_type === 3 ? "Weekly"
                        : +row.promo_type === 4 ? "Monthly"
                          : "For All"
                  }
                </td>
                <td style={{ minWidth: headers[2].width }}>
                  {+row.discount_type === 1 ? "Flat"
                    : +row.discount_type === 2 ? "Percentage"
                      : (+row.discount_type === 3 && row?.is_ffa) ? `${row.duration} ${row.duration === 1 ? +row.promo_type === 1 ? "Hour" : "Day" : +row.promo_type === 1 ? "Hours" : "Days"} Off`
                        : (+row.discount_type === 3 && !row?.is_ffa) ? `X Amount of ${+row.promo_type === 1 ? "Hours" : "Days"} OFF`
                          : ""
                  }
                </td>
                <td style={{ minWidth: headers[3].width }}>
                  {+row.discount_type === 1 ? `$${(row?.discount / 100)?.toFixed(2)}`
                    : +row.discount_type === 2 ? `${row.discount}%`
                      : +row.discount_type === 3 ? row.is_ffa ? "Free For All"
                        : row.duration : ""
                  }
                </td>
                <td style={{ minWidth: headers[4].width }}>{moment(row.start_date).utc().format("YYYY-MM-DD")}</td>
                <td style={{ minWidth: headers[5].width }}>{moment(row.expiry_date).utc().format("YYYY-MM-DD")}</td>
                <td style={{ minWidth: headers[6].width }}>
                  {row.total_usage || "0"}
                  {!!row.total_usage && (
                    <button
                      className="btn btn-sm bg-main text-white rounded mx-2"
                      onClick={() => getBookings(row.code, row.total_usage || 1)}
                    >
                      Show
                    </button>
                  )}
                </td>
                <td style={{ minWidth: headers[7].width }}>{row.limit_overall || "-"}</td>
                <td style={{ minWidth: headers[8].width }}>{row.limit_user || "-"}</td>
                <td style={{ minWidth: headers[9].width }}>{moment(row.expiry_date).utc().format("YYYY-MM-DD")}</td>
                <td style={{ minWidth: headers[10].width }}>{moment(row.createdAt).format("YYYY-MM-DD")}</td>
                <td style={{ minWidth: headers[11].width }}>
                  {row.is_cyclic ? "Yes" : "No"}
                  {row.is_cyclic && (
                    <button
                      style={{
                        backgroundColor: "rgb(255, 164, 89)",
                        border: "none",
                        color: "white",
                        borderRadius: "2px",
                        marginLeft: "6px",
                        padding: '4px'
                      }}
                      onClick={() => {
                        setPromoCycleId(row.cycle_id);
                        setOpenPromoCycleModal(true);
                      }}
                    >
                      Show All
                    </button>
                  )}
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  )
}